import React from "react";
import { Box, Chip, Button, TextField, Autocomplete } from "@mui/material";

const classColors = {
  'Стационарный': { backgroundColor: '#E4FBF1', color: '#1CA673' },
  'Мобильный': { backgroundColor: '#FFF9E6', color: '#FFC107' },
  'Передвижной': { backgroundColor: '#E3F2FD', color: '#2196F3' },
};

const classOptions = [
  { label: 'Стационарный', value: 'Стационарный' },
  { label: 'Мобильный', value: 'Мобильный' },
  { label: 'Передвижной', value: 'Передвижной' },
];

const inputSx = { "& .MuiOutlinedInput-root": { height: 44 } };

const Filter = ({ filter, onChange, onReset, onSearch }) => {
  const handleTextFieldChange = (e) => {
    onChange({ ...filter, page: 1, [e.target.name]: e.target.value });
  };
  const handleClassChange = (event, value) => {
    onChange({ ...filter, page: 1, class: (value || []).map((opt) => opt.value) });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField value={filter.complex_serial} onChange={handleTextFieldChange} label="Серийный номер" variant="outlined" name="complex_serial" className="--floating-label" fullWidth sx={inputSx} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField value={filter.model} onChange={handleTextFieldChange} label="Модель" variant="outlined" name="model" className="--floating-label" fullWidth sx={inputSx} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          value={classOptions.filter((opt) => (filter.class || []).includes(opt.value))}
          options={classOptions}
          fullWidth
          getOptionLabel={(option) => option?.label || ''}
          isOptionEqualToValue={(option, val) => option.value === val.value}
          renderOption={(props, option) => {
            const colors = classColors[option.value] || {};
            return (
              <li {...props} key={option.value}>
                <Chip label={option.label} size="small" sx={{ fontWeight: 600, fontSize: 12, pointerEvents: "none", ...colors }} />
              </li>
            );
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const colors = classColors[option.value] || {};
              return (
                <Chip {...getTagProps({ index })} key={option.value} label={option.label} size="small" sx={{ fontWeight: 600, fontSize: 12, ...colors, "& .MuiChip-deleteIcon": { color: colors.color, opacity: 0.7, "&:hover": { opacity: 1 } } }} />
              );
            })
          }
          renderInput={(params) => (
            <TextField {...params} label="Тип комплекса" className="--floating-label" sx={{ "& .MuiOutlinedInput-root": { minHeight: 44, display: "flex", alignItems: "center", "& input": { padding: "0 !important" } } }} />
          )}
          onChange={handleClassChange}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField value={filter.location} onChange={handleTextFieldChange} label="Местоположение" variant="outlined" name="location" className="--floating-label" fullWidth sx={inputSx} />
      </Box>
      <Button color="secondary" variant="contained" onClick={onReset} sx={{ flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500, textTransform: "none", whiteSpace: "nowrap" }}>Сбросить</Button>
      <Button variant="contained" onClick={onSearch} sx={{ flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500, textTransform: "none", whiteSpace: "nowrap" }}>Применить</Button>
    </Box>
  )
}

export default Filter;
